import { createFcmDetails } from '../shared/factory';

export const FCM_DETAILS_MOBILE_APP_DOWNLOAD_BOTTOM_BANNER_ENABLED = createFcmDetails(
	'mobile_app_download_bottom_banner_enabled',
	{
		owner: 'Mobile Squad',
		context: 'Starter Dashboard and Starter Petition Page',
		import: false,
		description:
			'This FC controls the rollout of the mobile app download CTA bottom banner on the starter dashboard and starter petition page(s)',
		template: {},
	},
);
